import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import api from '@/api'
import router from '@/router'
// import moment from 'moment'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'
/* eslint-disable no-param-reassign */
export default new Vuex.Store({
  state: {
    errorMessage: null,
    lang: 'zh',
    ai_sid: null,
    ai_uuid: null,

    auth: {
      authorized: false,
      user: null,
      userRole: null
    },

    isLoading: false,
    nodeEnv: process.env.NODE_ENV,
    auth_email: null,
    remainPoints: 0,
    playbackRate: 1,
    isOpenSubtitle: true,
    level: '初級',
    selectedAccent: 'en-EN' // 'en-EN ', 'it-IT', 'en-GB', 'en-AU'
  },

  getters: {
    authorized: state => state.auth.authorized,
    user: state => state.auth.user,
    ai_sid: state => state.ai_sid,
    ai_uuid: state => state.ai_uuid,
    isLoading: state => state.isLoading,
    lang: state => state.lang,
    remainPoints: state => state.remainPoints,
    isOpenSubtitle: state => state.isOpenSubtitle,
    playbackRate: state => state.playbackRate,
    level: state => state.level,
    selectedAccent: state => state.selectedAccent
  },

  actions: {
    refreshPageLogin: ({ commit, dispatch }) => {
      if (localStorage.getItem('ai_sid')) {
        commit('LOGIN', { sid: localStorage.getItem('ai_sid'), uuid: '' })
      } else if (localStorage.getItem('ai_uuid')) {
        commit('LOGIN', { sid: '', uuid: localStorage.getItem('ai_uuid') })
      }

      return dispatch('getRemainPoints')
    },
    // school
    loginSchool: ({ commit, dispatch }, data) => {
      let path = 'https://cloud.liveabc.com/api/tp/LiveSchool/login'
      let formData = new FormData()
      formData.append('token', data.token)
      return api.post(path, formData)
      .then(response => {
        if (response.data.access_token) {
          const myName1 = () => {
            return new Promise(async(resolve) => {
              localStorage.setItem('school_token', data.token)
              localStorage.setItem('authorizedAIToken', response.data.access_token)
              localStorage.setItem('ai_uuid', data.uuid)
              localStorage.setItem('uuid_expired_time', data.uuid_expired_time)
              setTimeout(() => {
                resolve('1')
              }, 1000)
            })
          }
          return Promise.race([myName1()])
          .then(() => {
            commit('LOGIN', { sid: '', uuid: data.uuid })
          })
        } else {
          alert('token已過期')
          location.replace('https://liveschool.liveabc.com/')
        }
      })
      .then(() => {
        return dispatch('getRemainPoints')
      })
      .catch((err) => {
        console.log(err)
      })
    },

    // 研三
    loginETA: ({ commit, dispatch }, payload) => {
      const sid = typeof payload === 'object' ? payload.sid : payload
      const s = typeof payload === 'object' ? payload.s : null
      localStorage.setItem('ai_sid', sid)

      let formData = new FormData()
      formData.append('sid', sid)

      let path = 'tp/aieta/login'
      if (s === 'elab') {
        path = 'tp/elab/login'
      }

      return api.post(path, formData)
      .then(response => {
        if (response.data.access_token) {
          localStorage.setItem('ai_sid', sid)
          localStorage.setItem('authorizedAIToken', response.data.access_token)
          commit('LOGIN', { sid: sid, uuid: '' })
          return dispatch('getRemainPoints')
        }
      })
      .catch((err) => {
        console.log(err)
      })
    },

    writeRecord: ({ dispatch }, records) => {
      // 寫入點數使用紀錄
      const CryptoJS = require('crypto-js')

      let user_sid = localStorage.getItem('ai_sid')
      let user_sid_check_code = (CryptoJS.MD5(CryptoJS.MD5(user_sid).toString() + user_sid).toString()).slice(-16)
      let random_code = Math.random().toString(36).substring(2, 2 + 16)

      let sentence_sn = records.sentence_sn ? records.sentence_sn : random_code

      let record_content = user_sid + records.conversation_id + sentence_sn + records.book + records.subject + records.unit + records.used_points
      let record_content_check_code = (CryptoJS.MD5(CryptoJS.MD5(record_content).toString() + (record_content)).toString()).slice(-16)

      let path = `https://aieta.liveabc.com/api/point/record/${user_sid}/${user_sid_check_code}/${random_code}/`
      if (localStorage.getItem('s') && localStorage.getItem('s') === 'elab') {
        path = `https://elab.liveabc.com/api/ai/point/record/${user_sid}/${user_sid_check_code}/${random_code}/`
      }

      let formData = new FormData()
      formData.append('conversation_id', records.conversation_id)
      formData.append('sentence_sn', sentence_sn)
      formData.append('book', records.book)
      formData.append('subject', records.subject)
      formData.append('unit', records.unit)
      formData.append('used_points', records.used_points)
      formData.append('record_content_check_code', record_content_check_code)
      api.post(path, formData, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        dispatch('getRemainPoints')
      })
      .catch((err) => {
        console.log(err)
      })
    },

    saveRecord: ({ dispatch }, records) => {
      // 儲存口說練習紀錄
      const CryptoJS = require('crypto-js')

      let user_sid = localStorage.getItem('ai_sid')
      let user_sid_check_code = (CryptoJS.MD5(CryptoJS.MD5(user_sid).toString() + user_sid).toString()).slice(-16)
      let random_code = Math.random().toString(36).substring(2, 2 + 16)

      let conversation_id_check_code = (CryptoJS.MD5(CryptoJS.MD5(user_sid + records.conversation_id).toString() + (user_sid + records.conversation_id)).toString()).slice(-16)

      let path = `https://aieta.liveabc.com/api/point/save/${user_sid}/${user_sid_check_code}/${random_code}/`

      let formData = new FormData()
      formData.append('conversation_id', records.conversation_id)
      formData.append('conversation_id_check_code', conversation_id_check_code)

      return api.post(path, formData, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        dispatch('getRemainPoints')
        if (response && response.data && response.data.response && response.data.response === 'OK') {
          return true
        }
      })
      .catch((err) => {
        console.log(err)
      })
    },

    // 官網
    loginWebsite: ({ commit, dispatch }, user) => {
      localStorage.removeItem('ai_sid')
      let path = 'https://cloud.liveabc.com/api/tp/LiveABC/login'

      axios.post(path, {
        'email': user.email,
        'password': user.password
      })
      .then(response => {
        commit('LOGIN', { sid: '', uuid: '' })
        localStorage.setItem('authorizedAIToken', response.data.access_token)
        dispatch('getRemainPoints')

        if (localStorage.getItem('ai_sid')) {
          localStorage.removeItem('ai_sid')
        }
        if (localStorage.getItem('ai_uuid')) {
          localStorage.removeItem('ai_uuid')
        }
        if (localStorage.getItem('school_token')) {
          localStorage.removeItem('school_token')
        }
        router.push({ name: 'Index' })
      })
      .catch((err) => {
        console.log(err)
      })
    },
    async loginByGoogle({ commit, dispatch }, token) {
      try {
        const path = 'https://cloud.liveabc.com/api/login/google'
        const response = await api.post(path, {
          token: token
        })

        if (response) {
          commit('LOGIN', { sid: '', uuid: '' })
          localStorage.setItem('authorizedAIToken', response.data.access_token)
          dispatch('getRemainPoints')
          // router.push({ name: 'Index' })
        }
      } catch (err) {
        console.error(err.response)
        window.location.href = 'https://store.liveabc.com/register'
      }
    },
    getRemainPoints: ({ commit }) => {
      if (localStorage.getItem('ai_sid')) {
        // 驗證 user 的 sid 並回應剩餘點數
        // 研三
        const CryptoJS = require('crypto-js')

        let user_sid = localStorage.getItem('ai_sid')
        let user_sid_check_code = (CryptoJS.MD5(CryptoJS.MD5(user_sid).toString() + user_sid).toString()).slice(-16)
        let random_code = Math.random().toString(36).substring(2, 2 + 16)

        const headers = {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Content-Type, Authorization',
          'Access-Control-Allow-Methods': '*',
          "Content-Type": "application/json"
        }

        let path = `https://aieta.liveabc.com/api/point/get/${user_sid}/${user_sid_check_code}/${random_code}`
        if (localStorage.getItem('s') && localStorage.getItem('s') === 'elab') {
          path = `https://elab.liveabc.com/api/ai/point/get/${user_sid}/${user_sid_check_code}/${random_code}`
        }

        return api.get(path, { headers: headers })
        .then(response => {
          if (response && response.data) {
            if (response.data.response && response.data.response === 'OK') {
              commit('SETPOINTS', response.data.points)
            } else {
              alert(response.data.response)
              location.replace('https://aieta.liveabc.com/')
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
      } else if (localStorage.getItem('ai_uuid')) {
        // 官網
        let path = `https://cloud.liveabc.com/api/tp/LiveSchool/points`

        return api.get(path)
        .then(response => {
          if (response && response.data) {
            commit('SETPOINTS', response.data.points)
          }
        })
        .catch((err) => {
          console.log(err)
        })
      } else {
        // 官網
        console.log('response')
        let path = `https://cloud.liveabc.com/api/tp/LiveABC/points`

        return api.get(path)
        .then(response => {
          if (response && response.data) {
            commit('SETPOINTS', response.data.points)
            commit('SETUSER', response.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
      }
    },

    // 其他
    isLoading: ({ commit }, data) => {
      commit('ISLOADING', data)
    },

    setLang: ({ commit }, data) => {
      commit('SETLANG', data)
    },

    setPlayBackRate: ({ commit }, data) => {
      commit('SETPLAYBACKRATE', data)
    },

    toggleSubtitle: ({ commit }, data) => {
      commit('TOGGLESUBTITLE', data)
    },

    logout: ({ commit }) => {
      commit('LOGOUT')

      localStorage.getItem('ai_sid') ? localStorage.removeItem('ai_sid') : null
      localStorage.getItem('ai_uuid') ? localStorage.removeItem('ai_uuid') : null
      localStorage.getItem('uuid_expired_time') ? localStorage.removeItem('uuid_expired_time') : null
      localStorage.getItem('authorizedAIToken') ? localStorage.removeItem('authorizedAIToken') : null
      localStorage.getItem('RD_pu') ? localStorage.removeItem('RD_pu') : null
      localStorage.getItem('RD_p') ? localStorage.removeItem('RD_p') : null
      localStorage.getItem('s') ? localStorage.removeItem('s') : null
    },

    setLevel: ({ commit }, data) => {
      commit('SETLEVEL', data)
    },
    setAccent: ({ commit }, data) => {
      commit('SETACCENT', data)
    }
  },
  mutations: {
    ISLOADING (state, data) {
      state.isLoading = data
    },
    SETLANG (state, value) {
      state.lang = value
      Vue.config.lang = state.lang
    },
    LOGIN (state, value) {
      state.auth.authorized = true
      // eslint-disable-next-line
      state.ai_sid = value.sid ? value.sid : null
      state.ai_uuid = value.uuid ? value.uuid : null
    },
    SETPOINTS (state, data) {
      state.remainPoints = data
    },
    SETUSER (state, data) {
      state.auth.user = data
    },
    SETPLAYBACKRATE (state, value) {
      state.playbackRate = value
    },
    TOGGLESUBTITLE (state, value) {
      state.isOpenSubtitle = value
    },
    LOGOUT (state) {
      state.auth.authorized = false
      state.remainPoints = 0
      state.auth.user = null
      state.ai_sid = null
      state.ai_uuid = null
    },
    SETLEVEL (state, value) {
      state.level = value
    },
    SETACCENT (state, value) {
      state.selectedAccent = value
    }
  },
  strict: debug,
  plugins: [createPersistedState({
    paths: [
      'auth'
    ]
  })]
})
